import mapboxgl from 'mapbox-gl'

export function extendBoundsFromCoordinates(bounds, coordinates) {
  if (typeof coordinates[0] === 'number') {
    bounds.extend(coordinates)
    return
  }
  coordinates.forEach((coord) => extendBoundsFromCoordinates(bounds, coord))
}

export function geometryToBounds(geometry) {
  const bounds = new mapboxgl.LngLatBounds()
  extendBoundsFromCoordinates(bounds, geometry.coordinates)
  return bounds
}

export function findPolygonFeatureBySiteId(polygonFeatures, siteId) {
  return polygonFeatures.find(
    (feature) => String(feature.properties.site_id) === String(siteId)
  )
}

export function resolvePolygonGeometry(properties, geometry, polygonFeatures) {
  if (geometry.type !== 'Point') return geometry

  return findPolygonFeatureBySiteId(polygonFeatures, properties.site_id)?.geometry
}
